import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './GretaAIChatChatListProjectsEmpty.module.css'

function GretaAIChatChatListProjectsEmpty() {
  const { t } = useTranslation()

  return (
    <Text isSecondary Element='p' className={styles.empty}>
      {t('Greta.ProjectsEmptyTextKey')}
    </Text>
  )
}

export default GretaAIChatChatListProjectsEmpty
